"use client";
import SectionPage from "@/components/common/section-page";

import {Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList,} from "@/components/ui/breadcrumb";
import CardTitle from "@/components/common/card-title";
import AwesomeCard from "@/components/common/awesome-card";
import { useNavigate } from "react-router-dom";
import ImageGallery from "@/components/common/image-gallery";

export default function Home() {
    const navigate = useNavigate();

    return (
        <div className={"flex flex-col gap-6 pb-6 bg-slate-100"}>
            <CardTitle
                title={"Culture, Patrimoine et Art"}
                backgroundImgSrc={"/images/card-title/Culture-Patrimoine-et-Art.jpg"}
            />

            {/* Breadcrumb */}
            <SectionPage sectionType="2xl">
                <div className={"flex justify-between items-center"}>
                    <Breadcrumb>
                        <BreadcrumbList>
                            <BreadcrumbItem>
                                <BreadcrumbLink href={"/"}>Culture, Patrimoine et Art</BreadcrumbLink>
                            </BreadcrumbItem>
                        </BreadcrumbList>
                    </Breadcrumb>
                </div>
            </SectionPage>

            {/* Nature & Biodiversité */}
            <SectionPage sectionType="2xl">
                <AwesomeCard
                    title={"Culture, Patrimoine et Art"}
                    className={"bg-white text-muted-foreground"}
                    titleClassName={"text-bleu-marine"}
                >
                    La Côte d’Ivoire, pays d’Afrique de l’ouest, frontalier avec cinq autres nations représente une
                    terre d’accueil pour ses voisins à qui elle a offert l’hospitalité et une cohabitation harmonieuse
                    devenant ainsi, un lieu de rencontre et d’inspirations de plusieurs peuples.
                    <br/>
                    <br/>
                    La Côte d’Ivoire a su tirer profit de son avantage non négligeable hérité du brassage culturel,
                    faisant d’elle une terre de référence en matière de culture. Son potentiel artistique est mis en
                    avant et sublimé par un dense, riche et varié vivier d’artiste en tout genre.
                    <br/>
                    <br/>
                    Depuis 2008, l’Unesco a pris soin d’inscrire quelques pratiques sociales, rituels et événements
                    festifs Ivoiriens tels le Gbofe (la musique des trompes traversières), le Balafon, le Zaouli sur la
                    liste représentative du patrimoine culturel immatériel de l’humanité.
                    <br/>
                    <br/>
                    Le pays tout entier a développé une tradition artistique, littéraire et musicale au fil des ans et
                    son riche patrimoine culturel va au-delà des musées, des mosquées et des basiliques.
                    <br/>
                    <br/>
                    Le génie de ses artistes s’est répandu dans toute l’Afrique et a conquis le monde tant sur le plan
                    musical que sur le plan de la mode et de l’artisanat. Une fierté non dissimulée pour ce peuple qui
                    met un point d’honneur à revendiquer son africanité dans tous les domaines.
                    <br/>
                    <br/>
                    Outre l’art populaire qui consiste en des activités informelles, non moins intéressantes comme la
                    fabrication de l’attiéké national ou la transformation du karité en beurre ou en savon, l’artisanat
                    traditionnel du pays s’exprime avec authenticité et ferveur. Le travail de l’or chez les Akans est
                    une activité d’orfèvre d’origine séculaire. Parmi les objets les plus symboliques de la culture
                    akan, les poids Baoulés qui servaient à peser la poudre d’or sont encore fondus selon la technique
                    ancestrale de la cire perdue. Le tissage reste l’apanage des Baoulés et des Sénoufos qui s’imposent
                    dans ce domaine.
                    <br/>
                    <br/>
                    La Côte d’Ivoire présente également une littérature abondante, riche de sa diversité de style et de
                    ses proverbes, soutenue par des infrastructures éditoriales relativement solides et des auteurs de
                    différentes notoriétés.
                    <br/>
                    <br/>
                    Une nouvelle génération d’artiste plus contemporain et digne représentant du street art, signale sa
                    présence avec des fresques dans certaines communes d’Abidjan.
                    <br/>
                    <br/>
                    Chacun de vos pas lors de votre visite en Côte d’Ivoire vous ouvre la porte sur une partie de
                    l’émouvante histoire de notre pays.

                    <div className={'mt-8'}>
                        <ImageGallery images={
                            Array.from({ length: 4 }).map((_, index) => ({
                                src: `/images/culture-patrimoine-art/galerie1/${index + 1}.jpg`,
                                alt: `image${index + 1}`,
                                width: 700,
                                height: 700,
                            }))
                        } aspectRatio={"video"} />
                    </div>
                </AwesomeCard>
            </SectionPage>

            {/* Quiétude et Félicité */}
            <SectionPage sectionType="2xl">
                <AwesomeCard
                    title={"Folklore et Tradition"}
                    className={"bg-white text-muted-foreground"}
                    titleClassName={"text-bleu-marine"}
                >
                    Avec 60 ethnies, le folklore de la Côte d’Ivoire est une culture vivante pittoresque qui se réinvente au niveau de ses croyances, rites, contes, légendes, fêtes, cultes, issues des sociétés traditionnelles.
<br/>
<br/>
                    En Côte d’Ivoire, aussi bien en plein centre urbain que dans le pays profond les peuples ont su préserver un mode traditionnel de vie   avec ses danses et ses masques, mais aussi ses villages aux habitations aux murs d’argiles recouverts d’une toiture de paille. Dans ses contrées, la cuisine est encore très simple et naturelle avec un goût exquis et les costumes traditionnels sont souvent à base de pagne artisanal tissé par les villageois et rehaussé de bijoux qui sont un couplage entre les perles peintes à la main localement et de l’or travaillé par les bijoutiers artisanaux.
                    <br/>
                    <br/>
                    Le folklore de la Côte d’ivoire comporte 60 teintes qui d’un village à un autre vous laissera un souvenir indélébile et une sensation d’appartenance grâce à l’intensité qui se dégage de l’Akwaba et toutes les découvertes surprenantes qui vous accompagneront tout au long de ce périple dans l’authenticité.

                    <div className={'mt-8'}>
                        <ImageGallery images={
                            Array.from({ length: 4 }).map((_, index) => ({
                                src: `/images/culture-patrimoine-art/galerie2/${index + 1}.jpg`,
                                alt: `image${index + 1}`,
                                width: 700,
                                height: 700,
                            }))
                        } aspectRatio={"video"} />
                    </div>
                </AwesomeCard>
            </SectionPage>
        </div>
    );
}
